export enum ResponseBodyType {
    UnknownError = 'UnknownError',
    ValidationError = 'ValidationError',
    Success = 'Success',
}
